import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Icon, Button } from "semantic-ui-react";
import Sidebar from "../../app/common/util/Sidebar";
import { connect } from "react-redux";
import NavBar from "../nav/NavBar/NavBar";
import OrderForm from "./OrderForm";
import { fetchFormData } from "./orderActions";
import LoaderComponent from "../../app/common/util/LoaderComponent";
import { doesFormDataExist } from "./formUtils";
import {
  getImageData,
  getInternalOrderId
} from "../whatsappOrders/whatsappOrderActions";
import { isEmpty } from "../../app/common/util/genericUtils";
class OrdersPage extends Component {
  state = {};
  componentWillMount() {
    const {
      formData,
      getImageData,
      match: { params }
    } = this.props;
    const dataFlag = doesFormDataExist();
    dataFlag && this.props.fetchFormData();
    if (isEmpty(formData)) {
      getImageData(params.id);
    }
  }

  render() {
    const {
      formData,
      loadingFormData,
      loadingOrderId,
      gettingImageData
    } = this.props;
    if (loadingFormData || loadingOrderId || gettingImageData) {
      return <LoaderComponent />;
    }
    return (
      <div>
        <Sidebar />
        <Button
          as={Link}
          to="/"
          icon
          labelPosition="left"
          style={{ margin: "5% 0 0 10%" }}
        >
          <Icon name="left arrow" />
          Back to Orders
        </Button>
        <OrderForm
          type="whatsapp"
          labelInValue={true}
          initialValues={formData}
        />
        <NavBar />
      </div>
    );
  }
}
const actions = {
  fetchFormData,
  getImageData,
  getInternalOrderId
};
const mapStateToProps = state => ({
  loadingFormData: state.orderForm.loadingFormData,
  formData: state.whatsappOrders.formData,
  loadingOrderId: state.whatsappOrders.loadingOrderId,
  gettingImageData: state.whatsappOrders.gettingImageData
});

export default connect(
  mapStateToProps,
  actions
)(OrdersPage);
